export const baseUrl ='https://api.themoviedb.org/3/'
export const API_KEY ='9fa98e23fcd028246d0a83dfc2a0d95a'
export const imageUrl ='https://image.tmdb.org/t/p/original'